import React, { useState, useEffect, useRef } from "react";
import ResponsiveWrapper from "../_responsive-wrapper";

const Tabs = ({ children }) => {
    const [activeTab, setActiveTab] = useState(0);
    const tabsRef = useRef(null);
    const validChildren = React.Children.toArray(children);

    useEffect(() => {
        if (typeof window === "undefined") return;

        validChildren.forEach((child, index) => {
            if (child.props.title === "Reviews" && window.location.hash === "#reviews") {
                setActiveTab(index);
                tabsRef?.current?.scrollIntoView({
                    behavior: "smooth",
                    inline: 'center'
                });
                window.history.replaceState(null, "", window.location.pathname);
            }
        });
    }, [children]);

    return (
        <ResponsiveWrapper className="tabs">
            <div className="tabs__titles" ref={tabsRef}>
                {validChildren.map((child, index) => (
                    // eslint-disable-next-line react/button-has-type
                    <button
                        key={child.props.title}
                        onClick={() => setActiveTab(index)}
                        className={`tabs__titles-button ${activeTab === index ? "tabs__titles-button--active" : ""}`}
                    >
                        {child.props.title}
                    </button>
                ))}
            </div>
            <div className="tabs__content">
                {validChildren.map((child, index) => (
                    <div key={child.props.title} className={`tabs__content-panel ${activeTab === index ? "tabs__content-panel--active" : ""}`}>
                        {child.props.children}
                    </div>
                ))}
            </div>
        </ResponsiveWrapper>
    );
};

export default Tabs;